<template>
  <div id="app" class="main-container">
    <Navbar />
    <Login v-if="!$store.state.currentUser" />
    <!-- Content -->
    <div class="container-fluid">
      <div v-bind:class="`${$store.state.sidebarStatus ? 'sidenav-container' : 'sidenav-none'}`">
        <Sidenav v-if="$store.state.sidebarStatus" />
      </div>
      <div v-bind:class="`${$store.state.sidebarStatus ? 'table-container-part' : 'table-container-full'}`">
        <router-view />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Sidenav from "@/components/Sidenav";
import Footer from "@/components/utils/footer";

export default {
  head: {
    link: [
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/icon?family=Material+Icons"
      }
    ]
  },
  components: {
    Navbar,
    Sidenav,
    Footer,
    // Login: () => import("@/components/Login"),
  },
  created() {
    const self = this
    self.$store.dispatch('checkLogin')
    // this.$store.dispatch('getPermissions', { token: this.$store.state.token })
  }
};
</script>

<style lang="scss">
@import "~/assets/scss/main.scss";
</style>
